import initEvents from './events'
import eventNames from './events/names'

const api = (instance) => {
    // store
    const addCriterias = (criterias) => {
        instance.store.addCriterias(criterias)
    }
    const removeCriterias = (criterias) => {
        instance.store.removeCriterias(criterias)
    }
    const setFieldValue = (field, value) => {
        instance.store.setFieldValue(field, value)
    }
    const addFieldValue = (field, value) => {
        instance.store.addFieldValue(field, value)
    }
    const removeFieldValue = (field, value) => {
        instance.store.removeFieldValue(field, value)
    }
    const clearRequest = (options) => {
        instance.store.clearRequest(options)
    }
    const clearFilters = (options) => {
        instance.store.clearFilters(options)
    }
    const setSort = (type, direction) => {
        instance.store.setSort({ type, direction })
    }
    const getSort = () => {
        return instance.store.getSort()
    }
    const setResultsPerPage = (num) => {
        instance.store.setResultsPerPage(num)
    }
    const getResultsPerPage = () => {
        return instance.store.getResultsPerPage()
    }
    const setPage = (page) => {
        instance.store.setPage(page)
    }
    const getPage = () => {
        return instance.store.getPage()
    }
    // criterias and field values
    const getAvailableCriterias = (criterias) => {
        // get available criterias from the list of criterias
        return instance.store.getAvailableCriterias(criterias)
    }
    const getSelectedCriterias = (criterias) => {
        // get selected criterias from the list of criterias
        return instance.store.getSelectedCriterias(criterias)
    }
    const getAvailableFieldValues = (field, values) => {
        // get available field values for the field
        return instance.store.getAvailableFieldValues(field, values)
    }
    const getAvailableCapacityValuesSorted = () => {
        // capacity specific getAvailableFieldValues
        return instance.store.getAvailableCapacityValuesSorted()
    }
    const getSelectedFieldValues = (field, values) => {
        // get available field values for the field
        return instance.store.getSelectedFieldValues(field, values)
    }
    const getFieldValue = (field) => {
        return instance.store.getFieldValue(field)
    }
    const getCounter = (field) => {
        return instance.store.getCounter(field)
    }
    const getValueCounter = (field, id) => {
        return instance.store.getValueCounter(field, id)
    }
    const getCriteriaCounter = (id) => {
        return instance.store.getCriteriaCounter(id)
    }

    const getSelected = ({ values, criterias }) => {
        return instance.store.getSelected({ values, criterias })
    }
    const isSelected = ({ values, criterias, availableOnly }) => {
        return instance.store.isSelected({ values, criterias, availableOnly })
    }
    const getAvailable = ({ values, criterias }) => {
        return instance.store.getAvailable({ values, criterias })
    }
    const isAvailable = ({ values, criterias }) => {
        return instance.store.isAvailable({ values, criterias })
    }
    const getAvailableNotSelected = ({ values, criterias }) => {
        return instance.store.getAvailableNotSelected({ values, criterias })
    }
    const hasAvailableNotSelected = ({ values, criterias }) => {
        return instance.store.hasAvailableNotSelected({ values, criterias })
    }
    const add = ({ values, criterias }) => {
        return instance.store.add({ values, criterias })
    }
    const remove = ({ values, criterias }) => {
        return instance.store.remove({ values, criterias })
    }

    // counters
    const setCriteriaCounters = (criterias) => {
        instance.store.setCriteriaCounters(criterias)
    }
    const setFieldCounters = (fields) => {
        instance.store.setFieldCounters(fields)
    }
    // exclude
    const setExcluded = ({ criterias, fields }) => {
        return instance.store.setExcluded({ criterias, fields })
    }
    const getExcluded = () => {
        return instance.store.getExcluded()
    }
    // counters
    const setExpectedCounter = (field, state) => {
        return instance.store.setExpectedCounter(field, state)
    }
    // special events
    const onSelectedCriterias = (criterias, fn, fired) => {
        return instance.store.onSelectedCriterias(criterias, fn, fired)
    }
    const onAvailableCriterias = (criterias, fn, fired) => {
        return instance.store.onAvailableCriterias(criterias, fn, fired)
    }
    const onFieldValue = (field, fn, fired) => {
        return instance.store.onFieldValue(field, fn, fired)
    }
    const onCounters = (counterFields, fn, fired) => {
        return instance.store.onCounters(counterFields, fn, fired)
    }
    const onSelectedFieldValues = (field, fn, fired) => {
        return instance.store.onSelectedFieldValues(field, fn, fired)
    }
    const onAvailableFieldValues = (criterias, fn, fired) => {
        return instance.store.onAvailableFieldValues(criterias, fn, fired)
    }

    const setSeason = (season) => {
        return instance.store.setSeason(season)
    }
    const getSeason = () => {
        return instance.store.getSeason()
    }

    const getSeRequest = () => {
        return instance.store.getSeRequest()
    }
    const getProductsQueryParams = () => {
        return instance.store.getProductsQueryParams()
    }

    // server
    // locale
    const setLocale = (locale) => {
        instance.server.setLocale(locale)
    }
    const request = () => {
        instance.server.request()
    }
    const requestProducts = () => {
        instance.server.requestProducts()
    }
    const requestCounters = () => {
        instance.server.requestCounters()
    }
    const requestStartDates = (month, nextMonth) => {
        return instance.server.requestStartDates(month, nextMonth)
    }
    const requestEndDates = (month, nextMonth, startDate) => {
        return instance.server.requestEndDates(month, nextMonth, startDate)
    }
    const requestGeoData = () => {
        instance.server.requestGeoData()
    }
    const requestGeoDataWithEngineId = () => {
        return instance.server.requestGeoDataWithEngineId()
    }
    const requestMap = () => {
        instance.server.requestMap()
    }
    const getRequestsInProgressNum = () => {
        return instance.server.getRequestsInProgressNum()
    }

    // server side requests
    const requestProductsByName = (name, options) => {
        return instance.server.requestProductsByName(name, options)
    }
    const requestProductsById = (ids) => {
        return instance.server.requestProductsById(ids)
    }
    const requestProductsByPrestId = (ids, options) => {
        return instance.server.requestProductsByPrestId(ids, options)
    }
    const requestPriceTransparency = ({ liheId, packCode, startDate, endDate, season, participantsAges }) => {
        return instance.server.requestPriceTransparency({ liheId, packCode, startDate, endDate, season, participantsAges })
    }
    const requestPriceTransparencyPriceForProduct = ({ product, prestation, participantsAges }) => {
        return instance.server.requestPriceTransparencyPriceForProduct({ product, prestation, participantsAges })
    }

    // sync
    const restoreCookies = () => {
        instance.cookies.restore()
    }
    const restoreUrl = () => {
        instance.url.restore()
    }
    const syncCookies = (syncState) => {
        instance.cookies.sync(syncState)
    }
    const syncUrl = (syncState) => {
        instance.url.sync(syncState)
    }
    const setOldUrlsMapper = (options) => {
        instance.url.setOldUrlsMapper(options)
    }
    const setUrlToStoreMapper = (options) => {
        instance.url.setUrlToStoreMapper(options)
    }
    const setStoreToUrlMapper = (options) => {
        instance.url.setStoreToUrlMapper(options)
    }
    const extendUrlToStoreMapper = (options) => {
        instance.url.extendUrlToStoreMapper(options)
    }
    const extendStoreToUrlMapper = (options) => {
        instance.url.extendStoreToUrlMapper(options)
    }
    const urlMapperIgnoreParams = (options) => {
        instance.url.urlMapperIgnoreParams(options)
    }
    // removeEndDate hotfix for train project, not my idea
    const getUrl = (removeEndDate = false) => {
        return instance.url.getUrl(removeEndDate)
    }

    const getSeStoreState = () => {
        return instance.url.getStoreState()
    }

    const getProducts = () => {
        return instance.store.getProducts()
    }
    const getProductsNum = () => {
        return instance.store.getProductsNum()
    }
    const getPagesNum = () => {
        return instance.store.getPagesNum()
    }

    // engine
    const getEngine = () => {
        return instance.store.getEngine()
    }
    const setEngine = (engine) => {
        instance.store.setEngine(engine)
    }
    const getEngineId = () => {
        return instance.store.getEngineId()
    }
    const setEngineId = (engineId) => {
        instance.store.setEngineId(engineId)
    }

    const getParticipantsAges = () => {
        return instance.cookies.getParticipantsAges()
    }
    const setParticipantsAges = (participantsAges) => {
        return instance.cookies.setParticipantsAges(participantsAges)
    }

    const getAdultAge = () => {
        return instance.options.adultAge
    }

    const getMapData = () => {
        return instance.store.getMapData()
    }

    const getGeoData = () => {
        return instance.store.getGeoData()
    }

    // events
    const events = initEvents(instance)

    const batch = (fn) => {
        instance.store.batch(fn)
    }
    const storeBatch = instance.store.batch
    instance.store.batch = (...props) => {
        events.batch(() => storeBatch(...props))
    }
    const serverBatch = instance.server.batch
    instance.store.batch = (...props) => {
        events.batch(() => serverBatch(...props))
    }
    const cookiesBatch = instance.store.batch
    instance.store.batch = (...props) => {
        events.batch(() => cookiesBatch(...props))
    }

    return {
        // locale
        setLocale,

        // filters
        addCriterias,
        removeCriterias,
        setFieldValue,
        addFieldValue,
        removeFieldValue,
        clearRequest,
        clearFilters,

        getParticipantsAges,
        setParticipantsAges,
        getAdultAge,

        // results controls
        setSort,
        getSort,
        setResultsPerPage,
        getResultsPerPage,
        setPage,
        getPage,

        // criterias and field values
        getAvailableCriterias,
        getSelectedCriterias,
        getAvailableFieldValues,
        getAvailableCapacityValuesSorted,
        getSelectedFieldValues,
        getFieldValue,
        getCounter,
        getValueCounter,
        getCriteriaCounter,

        // values & criterias
        getSelected,
        isSelected,
        getAvailable,
        isAvailable,
        getAvailableNotSelected,
        hasAvailableNotSelected,
        add,
        remove,

        // counters
        setCriteriaCounters,
        setFieldCounters,

        // exclude
        setExcluded,
        getExcluded,

        // counters
        setExpectedCounter,

        // sync
        restoreCookies,
        restoreUrl,
        syncCookies,
        syncUrl,
        setOldUrlsMapper,
        setUrlToStoreMapper,
        setStoreToUrlMapper,
        extendUrlToStoreMapper,
        extendStoreToUrlMapper,
        urlMapperIgnoreParams,

        getUrl,

        setSeason,
        getSeason,

        getSeRequest,
        getProductsQueryParams,

        // locale
        setLocale,

        // requests
        request,
        requestProducts,
        requestCounters,
        requestStartDates,
        requestEndDates,
        requestGeoData,
        requestGeoDataWithEngineId,
        requestMap,
        getRequestsInProgressNum,

        // server side requests
        requestProductsByName,
        requestProductsById,
        requestProductsByPrestId,
        requestPriceTransparency,
        requestPriceTransparencyPriceForProduct,

        // results
        getProducts,
        getProductsNum,
        getPagesNum,

        // engine
        getEngine,
        setEngine,
        getEngineId,
        setEngineId,

        // map
        getMapData,

        // geo
        getGeoData,

        // events
        events: eventNames,
        on: events.on,
        once: events.once,
        off: events.off,
        ignore: events.ignore,
        batch,

        // special events
        onSelectedCriterias,
        onAvailableCriterias,
        onFieldValue,
        onCounters,
        onSelectedFieldValues,
        onAvailableFieldValues,
        getSeStoreState
    }
}

export default api
